import esContent from './emailVerify.es';

export default {
  ...esContent,
};
